














import { defineComponent, useContext, computed } from '@nuxtjs/composition-api';
import { SfBreadcrumbs } from '~/components/StorefrontUi';
import { STORE_URL } from '~/config/base';
import { Breadcrumb } from '~/modules/catalog/types';

export default defineComponent({
  name: 'BlogBreadcrumbs',
  components: { SfBreadcrumbs },
  props: {
    currentStory: {
      type: Object,
      default: null,
    },
  },
  setup({ currentStory }) {
    const { localePath, i18n, $localeSbUrl } = useContext();
    const getStoryType = computed(() => {
      const currentStoryComponent = currentStory?.content?.component;

      switch (currentStoryComponent) {
        case 'blogArticle':
        case 'blogFile': {
          return 'article';
        }
        case 'blogSubCategory':
        case 'blogSubCategory_files': {
          return 'sub-category';
        }
        case 'blogCategory': {
          return 'category';
        }
        default: {
          return 'index';
        }
      }
    });

    const basicBreadcrumbs: Breadcrumb[] = [
      {
        text: `${i18n.t('Homepage')}`,
        link: localePath('/'),
      },
      {
        text: 'Blog',
        link: localePath('/blog'),
      },
    ];

    const breadcrumbs = computed((): Breadcrumb[] => (getStoryType.value !== 'index'
      ? [
        ...basicBreadcrumbs,
        {
          text: currentStory?.name ?? '',
          link: $localeSbUrl({ slug: currentStory?.full_slug }) ?? '',
        },
      ]
      : basicBreadcrumbs));

    const getBreadcrumbsSchema = () => JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: breadcrumbs.value.map((breadcrumb, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name: breadcrumb.text,
        item: `${STORE_URL}${breadcrumb.link}`,
      })),
    });

    return {
      getBreadcrumbsSchema,
      getStoryType,
      breadcrumbs,
    };
  },
});
